export default __webpack_public_path__ + "static/Preparation-4f7a5a09445c5f64946eefb29cb8c7dd.pdf";